import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { RobotoTooltip } from "@/shared/components/RobotoTooltip";
import { actions, useVizDispatch } from "@/shared/state/visualization";
import { TimeBoundsSource } from "@/shared/state/visualization/schema";

import styles from "./SelectTimeBoundsSource.module.css";

interface SelectTimeBoundsSourceProps {
  disabled?: boolean;
  panelId: string;
  timeBoundsSource: TimeBoundsSource;
}

const DISABLED_EXPLANATION =
  "Time Range is unavailable while the x axis is aligned: it applies only to absolute time.";

const TimeBoundsSourceLabels: Record<TimeBoundsSource, string> = {
  [TimeBoundsSource.FilesInPanel]: "Only files in this panel",
  [TimeBoundsSource.FilesInWorkspace]: "All files in workspace",
  [TimeBoundsSource.TopicsInPanel]: "Only topics in this panel",
};

export function SelectTimeBoundsSource({
  disabled = false,
  panelId,
  timeBoundsSource,
}: SelectTimeBoundsSourceProps) {
  const dispatch = useVizDispatch();

  const onTimeBoundsSourceChange = (event: SelectChangeEvent) => {
    dispatch(
      actions.setPlotPanelConfig(panelId, {
        timeBoundsSource: event.target.value as TimeBoundsSource,
      }),
    );
  };

  const control = (
    <FormControl className={styles.container} fullWidth>
      <Select
        labelId="time-bounds-source-label"
        id="time-bounds-source-select"
        value={timeBoundsSource}
        onChange={onTimeBoundsSourceChange}
        size="small"
        className={styles.smallFont}
        disabled={disabled}
      >
        {Object.values(TimeBoundsSource).map((value) => (
          <MenuItem key={value} value={value} className={styles.smallFont}>
            {TimeBoundsSourceLabels[value]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  if (!disabled) {
    return control;
  }

  return <RobotoTooltip title={DISABLED_EXPLANATION}>{control}</RobotoTooltip>;
}
